module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_f_albino.2db91ebe.png";